import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import BlockSection from '../../tabs/AssetsDetailsBlockSection';
import MetadataUtil from '../../util/MetadataUtil';
import MetadataInputComponent from './MetadataInputComponent';

import '../../tabs/assets/AssetsDetailsStyle.css';
import classNames from 'classnames';
import { Separator } from '../../common/form';
import { EditMetadataRow } from '../../metadata/edit-metadata/component/EditMetadataRow';
import HashMap from '../../protocol/HashMap';

export default class MetadataPanel extends React.Component {
  static propTypes = {
    groupCode2PropIdMetadataValueMap: PropTypes.object,
    fullId2ValueMap: PropTypes.object,
    forceNonEditable: PropTypes.bool,
    applyPaddingTop: PropTypes.bool,
    onChangeHandler: PropTypes.func,
    panelOpen: PropTypes.bool,
    filterEmptyValues: PropTypes.bool,
    onKeyDownEnter: PropTypes.func,
    searchValue: PropTypes.string,
    dirtyPropName2ValueMap: HashMap
  };

  static defaultProps = {
    forceNonEditable: false,
    applyPaddingTop: true,
    panelOpen: false
  };

  onChangeHandler(fullPropName, propValue) {
    this.props.onChangeHandler(fullPropName, propValue);
  }

  render() {
    const { dirtyPropName2ValueMap } = this.props;
    return (
      <div>
        {this.props.groupCode2PropIdMetadataValueMap && this.props.groupCode2PropIdMetadataValueMap !== null
          ? this.renderGroupCodeTopPropDetail(this.props.groupCode2PropIdMetadataValueMap, dirtyPropName2ValueMap)
          : this.renderMetadataData(this.props.fullId2ValueMap, dirtyPropName2ValueMap)}
      </div>
    );
  }

  renderMetadataData(imageData, dirtyPropName2ValueMap) {
    if (!imageData || imageData == null) return null;
    let groupCode2PropIdMetadataValueMap = this.groupMetadataElements(imageData);
    return this.renderGroupCodeTopPropDetail(groupCode2PropIdMetadataValueMap, dirtyPropName2ValueMap);
  }

  renderGroupCodeTopPropDetail(__groupCode2PropIdMetadataValueMap, dirtyPropName2ValueMap) {
    let output = [];
    for (let key in __groupCode2PropIdMetadataValueMap) {
      if (__groupCode2PropIdMetadataValueMap.hasOwnProperty(key)) {
        output.push(this.renderMetadataGroup(key, __groupCode2PropIdMetadataValueMap[key], dirtyPropName2ValueMap));
      }
    }
    return output;
  }

  groupMetadataElements(propId2ValueMap) {
    return MetadataUtil.ConvertToGroup2PropObject(propId2ValueMap);
  }

  renderMetadataGroup(groupCode, propIdsInGroup, dirtyPropName2ValueMap: HashMap) {
    const searchValue: string = this.props.searchValue?.trim()?.replace(/\s+/g, ' ')?.toLowerCase()
    if (propIdsInGroup.length === 0) return null;
    const items = _.compact(
      _.map(propIdsInGroup.keys(), (propId: string) => {
        const value: string = propIdsInGroup.get(propId)?.toLowerCase();
        if (value?.match(searchValue) || propId?.toLowerCase()?.match(searchValue)) {
          const fullPropName = groupCode + '_' + propId;
          const dirtyValue = dirtyPropName2ValueMap?.toMap().get(fullPropName);
          const value =   dirtyValue ?  dirtyValue : propIdsInGroup.get(propId);
          // console.log(dirtyPropName2ValueMap, value)
          return this.renderMetadataItem(groupCode, propId, value)
        } else return false;
      })
    );
    if (this.props.filterEmptyValues && !items.length) {
      return null;
    }

    let title;
    try {
      title = window.gs.groupCode2GroupInfoMap.get(groupCode).getGroupName();
    } catch (err) {
      title = groupCode;
    }
    return items.length ?
      (
        <div key={groupCode} className="moreInfo">
          <EditMetadataRow text={title} searchValue={searchValue}>
            {items}
          </EditMetadataRow>
          <Separator/>
        </div>
      ) : null
  }

  renderMetadataItem(groupCode, propId, propValue) {
    if (this.props.filterEmptyValues && !propValue) {
      return null;
    }

    return (
      <div key={propId} className={classNames('flex-row')}
      style={{ height: 40 }}
      >
        <div className='flex-row'  style={styles.presets}>{propId}</div>
        {this.prepareInputForItem(groupCode, propId, propValue)}
      </div>
    );
  }

  prepareInputForItem(groupCode, propId, propValue) {
    const fullPropName = groupCode + '_' + propId;
    if (!window.gs.propName2PropInfoMap) {
      console.warn('window.gs.propName2PropInfoMap is null');
      return null;
    }
    let propInfo = window.gs.propName2PropInfoMap.get(fullPropName);
    let editable = false;
    if (!this.props.forceNonEditable) {
      editable = propInfo._editable;
    }
    return (
      <MetadataInputComponent
        onChangeHandler={(value) => this.onChangeHandler(fullPropName, value)}
        propValue={propValue}
        editable={editable}
        propInfo={propInfo}
        fullPropName={fullPropName}
        onKeyDownEnter={this.props.onKeyDownEnter}
      />
    );
  }
}
const styles = {
  input: {
    height: '61px',
    margin: '20px 0 0 0'
  },
  presets: {
    // textTransform: 'uppercase',
    height: '15px',
    width: '50%',
    color: '#B5B5B5',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '1px',
    lineHeight: '15px',
    alignSelf: 'center'
  }
};
